import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";
// import { start } from "repl";

@Component({
  selector: "app-ssr-master",
  templateUrl: "./ssr-master.component.html",
  styleUrls: ["./ssr-master.component.css"]
})
export class SsrMasterComponent implements OnInit {
  showList: boolean = false;
  searchlist: boolean = false;
  validflag = false;
  viewpage = false;
  searchresult = false;
  loader: any = false;
  editFlag: any = false;
  screen_details: any = [];
  search_details: any = [];
  searchtabledata: any = [];
  childtables = [];
  EditData: any = [];
  filters = [];
  validflagform = {};
  actionmode: string = "Search";
  screentitle: string = "SSR Master";
  parent_table = "mst_insurance";
  delete_id = "";
  screen_name = "ssr";
  providers = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "ICICI Lombard" },
    { "id": "2", "value": "BRB" },
    { "id": "3", "value": "LGI" }
  ]
  //   dbFields = [
  //     "TRAVEL_START", "TRAVEL_END", "COST_PRICE", "COST_PRICE_NO_GST", "MARKUP", "PLOUGHBACK", "RPM"
  //     , "COMMISSION", "SCREEN_NAME", "Flight_Type", "INSURANCE_PROVIDER"
  //     // this.APPLICABLE_FROM,
  //     // this.APPLICABLE_TO
  //     // this.IS_LOGIN
  //   ];
  dbFields = [
    "PLOUGHBACK", "RPM"
    , "COMMISSION", "SCREEN_NAME"
    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO
    // this.IS_LOGIN
  ];
  constructor(private vernostService: VernostServiceService, private commonService: CommonService) { }
  ngOnInit() {
    this.searchData(true);
  }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.validflag = false;
    this.validflagform = {};
    if (this.screen_name != 'zero_canc') {
      this.screen_details.Insurance_Provider = '';
      this.screen_details.Flight_Type = '';
    }
  }

  searchForm(show_error_msg) {

    this.actionmode = "Search";
    this.editFlag = false;
    this.screen_details = [];
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    this.searchData(show_error_msg);

  }


  submitcancelData() {
    this.validate()
    let id;
    if(this.EditData.length > 0) {
      id = this.EditData[0]["ID"];
    }

    var formData = [
      this.screen_details.Ploughback,
      this.screen_details.RPM,
      this.screen_details.Commission,
      this.screen_name
    ];

    if (this.editFlag == false) {
      this.checkRecordInDB().then(isRecordInDB => {
        if (!isRecordInDB) {
          console.log("checkRecordInDB():", isRecordInDB);
          var DataSsrRequest = {
            parent_table: this.parent_table,
            dbFields: this.dbFields,
            formData: formData,
            // USER_ID: this.uid,
            PAGENAME: "BANNER"
          };
          this.vernostService.insertData(DataSsrRequest).subscribe(response => {
            console.log("insert:", response)
            if (response[0].message == "Data inserted") {
              this.removeEditScreen();
              // document.getElementById("errs").innerHTML =
              //   "Record Created Successfully";
              this.showMessagePopup("Record Inserted Successfully");
              this.screen_details = [];
              this.validflag = false;

            } else {
              // document.getElementById("errs").innerHTML = 
              this.showMessagePopup("Record Not Inserted Successfully");
            }
          });
        }
      })
    }
    if (this.editFlag == true) {

      console.log("EditData=" + this.EditData[0]["ID"]);
      console.log("this.EditData=" + JSON.stringify(this.EditData));
      var arraySsrRequest = {
        parent_table: this.parent_table,
        dbFields: this.dbFields,
        parent_table_ID: "ID",
        formData: formData,
        formdataId: id,
        USER_ID: ""
      };
      this.vernostService.editData(arraySsrRequest).subscribe(response => {
        console.log("edit:", response)
        if (response != undefined && response[0].status != "Failed") {

          this.removeEditScreen();
          // document.getElementById("errs").innerHTML = 
          this.showMessagePopup("Record Updated Successfully")
          this.screen_details = [];
          this.validflag = false;

        } else {
          // document.getElementById("errs").innerHTML = 
          this.showMessagePopup("Record Not Updated Successfully")
        }
      });

    }
    // }
  }
  searchData(show_error_msg) {
    this.searchlist = false;
    this.loader = true;
    var searchitem = [];
    var searchColumn = [];
    searchitem.push(this.screen_name);
    searchColumn.push("SCREEN_NAME");
    var Data = {
      parent_table: this.parent_table,
      dbFields: searchColumn,
      searchData: searchitem,
      childtables: this.childtables,
      filters: this.filters
    };
    this.vernostService.searchRecord(Data).subscribe(response => {
      this.loader = false;
      this.searchtabledata = response;
      if (response.length > 0) {
        this.searchresult = true;
        this.searchtabledata = response;
        document.getElementById("errs").innerHTML = "";
      } else {
        this.searchresult = false;
        this.showMessagePopup("Record not found");
      }
    });
  }
  showFormData(data, flag) {
    this.EditData = [];
    this.EditData.push(data);
    if (flag == 1) {
      this.editFlag = false;
      this.actionmode = "view";
      this.viewpage = true;
    } else {
      this.editFlag = true;
      this.delete_id = data.ID;
      this.actionmode = "Edit";
      //   this.screen_details.Travel_Start_Date = data.TRAVEL_START;
      //   this.screen_details.Travel_End_Date = data.TRAVEL_END;
      //   this.screen_details.Cost_Price = data.COST_PRICE;
      //   this.screen_details.Cost_Price_No_GST = data.COST_PRICE_NO_GST;
      //   this.screen_details.Mark_Up = data.MARKUP;
      this.screen_details.Ploughback = data.PLOUGHBACK;
      this.screen_details.RPM = data.RPM;
      this.screen_details.Commission = data.COMMISSION;
      this.screen_details.Flight_Type = data.FLIGHT_TYPE;
      this.screen_details.SSR_Type = data.SSR_TYPE;
      //   this.screen_details.Insurance_Provider = data.INSURANCE_PROVIDER;
      // if(this.screen_name=="ti_dom")
      // this.screen_details.Cost_Price = 199;
      // this.screen_details.Band_Name = data.BAND_NAME;

    }
    this.validflag = this.validate();
   
  }

  numcheck(id) {

    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+$/);
    this.validflag = this.validate();
  }


  decimalcheck(id) {
    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+(\.[0-9]+)?$/);
    this.validflag = this.validate();
  }


  blankcheck(id) {
    this.validflagform[id] = this.commonService.blankcheck(this.screen_details[id], id);
    this.validflag = this.validate();
  }



  deleteData() {
    var deleteReq_ssr = {
      ID: this.delete_id
    };
    this.vernostService.DeleteInsuranceArray(deleteReq_ssr).subscribe(response => {
      console.log("Delete:-", response);
      if (response != undefined && response[0]["status"] == "Success") {
        this.screen_details = [];
        this.removeEditScreen();
        this.showMessagePopup("Record Deleted Successfully")
      } else {
        this.showMessagePopup("Record Not Deleted Successfully")
      }
    });
  }


  removeEditScreen() {
    this.actionmode = "Search";
    this.viewpage = false;
    this.editFlag = false;
    document.getElementById("errs").innerHTML = "";
    this.searchForm(false);

  }


  showMessagePopup(msg) {
    document.getElementById("errs").innerHTML = msg;
    setTimeout(() => {document.getElementById("errs").innerHTML = "";}, 2000);
  }


  setScreen(screen) {
    this.screen_name = screen;

    if(this.screen_name == 'ti_dom') {
      this.screen_details.Cost_Price = 199;
    }

    this.actionmode = "Search";
    this.screen_details = [];
    this.validflag = false;
    this.editFlag = false;
   
    document.getElementById("errs").innerHTML = "";
    this.searchresult = false;
    this.viewpage = false;
    this.search_details = [];
    this.loader = false;
    this.search_details.Flight_Type = '';
  }


  validate() {
    var errs = document.getElementsByClassName("err");
    for (var e = 0; e < errs.length; e++) {
      var key = errs[e].id.slice(0, -4);
      if (this.validflagform[key] == undefined) {
        if (this.screen_details[key] === undefined || 
          this.screen_details[key] == null || 
          this.screen_details[key] === "") {
          this.validflagform[key] = false;
          return false;
        }
        else {
          this.validflagform[key] = true;
        } 
      }
      else {
        if (this.validflagform[key] === false) {
          return false;
        }
      }
    }
    return true;
  }


  checkRecordInDB() {
    return new Promise(resolve => {
      var Data = {
        parent_table: this.parent_table,
        searchData: [this.screen_name],
        dbFields: ["SCREEN_NAME"],
        childtables: this.childtables,
        filters: this.filters
      }
      //   if (this.screen_name != "ti_dom") {
      //     Data.dbFields.push("TRAVEL_START");
      //     Data.searchData.push(this.screen_details.Travel_Start_Date);

      //     Data.dbFields.push("TRAVEL_END");
      //     Data.searchData.push(this.screen_details.Travel_End_Date);
      //   }
      //   if (this.screen_name != "zero_canc") {
      Data.dbFields.push("FLIGHT_TYPE");
      Data.searchData.push(this.screen_details.Flight_Type);
      //   }
      this.vernostService.searchRecord(Data).subscribe(response => {
        this.loader = false;
       
        // this.searchtabledata = response;
        if(response.length > 0) {
          this.showMessagePopup("Record already exists !");
          resolve(true);
        } 
        else {
          resolve(false);
        }
      });
    
    })
  }


  checkLimit(id, min, max) { 
    this.validflagform[id] = this.commonService.checkLimit(id, min, max, this.screen_details[id], this.validflagform[id]);
    this.validflag = this.validate();
  }

  ceil(num) {
    return Math.ceil(num);
  }
  round(num) {
    return Math.round(num);
  }
  getInsProvider(provider_key) {
    for (var provider of this.providers) {
      if (provider_key == provider.id)
        return provider["value"];
    }
    return "";
  }
  getMilesValue(COST_PRICE_NO_GST, COMMISSION, PLOUGHBACK, RPM) {
    var miles = Math.round((((COST_PRICE_NO_GST * COMMISSION / 100) * (PLOUGHBACK / 100)) / (RPM / 100)) / 25) * 25;
    return (miles < 25) ? 25 : miles;
  }
}
